// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V615","rootMobile":"styles_rootMobile__cMz60"};